import type { ReactNode } from 'react';

interface Props {
  id?: string;
  eyebrow?: string;
  title: string;
  description?: string;
  children: ReactNode;
}

export function GuideSection({ id, eyebrow, title, description, children }: Props) {
  return (
    <section id={id} className="scroll-mt-24">
      <header className="mb-6">
        {eyebrow && (
          <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.22em] text-neurax-electric/80">
            {eyebrow}
          </p>
        )}
        <h2 className="font-display text-2xl font-semibold text-white sm:text-3xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{description}</p>
        )}
      </header>
      <div className="space-y-5">{children}</div>
    </section>
  );
}
